import React from "react";
import { Link } from "react-router-dom";
import { policyGroups } from "../Datas/policyData";
import "../css/policy.scss";

function PolicyIndex() {
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <main className="policy-page policy-index-page">
      <div className="policy-container policy-index-container">
        <header className="policy-header">
          <p className="policy-kicker">Help & legal</p>
          <h1>Policies</h1>
          <p>
            Clear information about shopping with isanroute, how we handle data,
            and the standards that apply when you use this website.
          </p>
        </header>

        {policyGroups.map((group) => (
          <section className="policy-group" key={group.title}>
            <h2>{group.title}</h2>
            <div className="policy-card-grid">
              {group.items.map((item) => (
                <Link className="policy-card" to={item.path} onClick={toTop} key={item.path}>
                  <h3>{item.title}</h3>
                  <p>{item.summary}</p>
                  <span aria-hidden="true">Read policy →</span>
                </Link>
              ))}
            </div>
          </section>
        ))}
      </div>
    </main>
  );
}

export default PolicyIndex;
